(function () {
  var root = document.querySelector(".ss-contact");
  if (!root) return;

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var topicSelect = root.querySelector("#ss-contact-topic");
  var orderField = root.querySelector("[data-field='order']");
  var phoneField = root.querySelector("[data-field='phone']");
  var messageField = root.querySelector("#ss-contact-message");

  var placeholders = {
    "Order status": "Please include any details about your order — we'll look it up and get back to you quickly.",
    "Product question": "Ask us about ingredients, how to take a product, or which ADDY might be right for you.",
    "Return or refund": "Tell us why you'd like to return and whether the product was opened. We'll guide you through our 60-day guarantee.",
    Wholesale: "Tell us about your business and what you're interested in carrying.",
    Other: "How can we help you today?",
  };

  function updateFormFields() {
    if (!topicSelect) return;
    var topic = topicSelect.value;
    var showOrder = topic === "Order status" || topic === "Return or refund";
    var showPhone = topic === "Order status" || topic === "Return or refund";

    if (orderField) {
      orderField.classList.toggle("is-hidden", !showOrder);
      var orderInput = orderField.querySelector("input");
      if (orderInput) orderInput.disabled = !showOrder;
    }
    if (phoneField) {
      phoneField.classList.toggle("is-hidden", !showPhone);
      var phoneInput = phoneField.querySelector("input");
      if (phoneInput) phoneInput.disabled = !showPhone;
    }
    if (messageField && placeholders[topic]) {
      messageField.placeholder = placeholders[topic];
    }
  }

  if (topicSelect) {
    topicSelect.addEventListener("change", updateFormFields);
    updateFormFields();
  }

  function initReveal() {
    var els = root.querySelectorAll(".ss-reveal");
    if (!els.length) return;

    if (reducedMotion) {
      els.forEach(function (el) {
        el.classList.add("ss-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("ss-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -24px 0px" }
    );

    els.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initReveal);
  } else {
    initReveal();
  }
})();
